import { render, staticRenderFns } from "./RasConfigurazionePostiLettoPianiListPage.vue?vue&type=template&id=a8e00eba"
import script from "./RasConfigurazionePostiLettoPianiListPage.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoPianiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports